import React from "react";
import { Wheel } from "react-custom-roulette";

// Example of predefined colors
const wheelColors = [
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
  "#B3B31A",
  "#00E680",
  "#4D8066",
  "#809980",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#9900B3",
  "#E64D66",
  "#4DB380",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
];

const WheelSection = ({
  choices,
  spinning,
  selectedChoiceIndex,
  handleStopSpinning,
}) => {
  // Ensure we have enough colors for all choices
  const getColors = () => {
    const colors = [];
    for (let i = 0; i < choices.length; i++) {
      colors.push(wheelColors[i % wheelColors.length]); // Cycle through colors if not enough
    }
    return colors;
  };

  const colorArray = getColors();

  return (
    <div className="wheel-container mb-5">
      {choices.length > 0 && (
        <Wheel
          mustStartSpinning={spinning}
          prizeNumber={selectedChoiceIndex}
          data={choices.map((choice, index) => ({
            option: choice,
            style: {
              backgroundColor: colorArray[index], // Use unique color for each item
            },
          }))}
          onStopSpinning={handleStopSpinning}
        />
      )}
    </div>
  );
};

export default WheelSection;
